export default __webpack_public_path__ + "static/media/icons-edit-18-px.48620c54.svg";